module.exports = __webpack_public_path__ + "static/media/03.22ceac35.png";